import React, { useState, useRef, useEffect } from "react";
import { func, instanceOf, bool } from "prop-types";
import { Form } from "react-bootstrap";
import DateFnsUtils from "@date-io/date-fns";
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { usePopper } from "react-popper";
import FocusTrap from "focus-trap-react";
import { formatDateToTime } from "../../utils/helperFunctions";

const TimePickInput = ({
  timeValue,
  handleTimeChange,
  showEventExpirationTimeError,
  fromExtendEventExpiration,
}) => {
  const [date, setDate] = useState(timeValue || new Date());
  const [isPopperOpen, setIsPopperOpen] = useState(false);
  const [popperElement, setPopperElement] = useState(null);

  const popperRef = useRef(null);

  const popper = usePopper(popperRef.current, popperElement, {
    placement: "bottom-start",
  });

  const closePopper = () => {
    setIsPopperOpen(false);
  };

  useEffect(() => {
    setDate(timeValue || new Date());
  }, [timeValue]);

  useEffect(() => {
    if (showEventExpirationTimeError) {
      closePopper();
    }
  }, [showEventExpirationTimeError]);

  const handleOnClick = () => {
    setIsPopperOpen(true);
  };

  return (
    <div
      className="d-inline-block ml-2"
      style={{
        position: "relative",
        width: fromExtendEventExpiration ? "30%" : "25%",
      }}
    >
      <div ref={popperRef}>
        <Form.Control
          type="text"
          className="timePickerInput"
          onClick={handleOnClick}
          value={formatDateToTime(date)}
          readOnly
          style={{
            border: showEventExpirationTimeError ? "1px solid #d50057" : "",
          }}
        />
      </div>
      {showEventExpirationTimeError ? (
        <p className="manual-override-invalid-feedback mb-0">
          Please select a valid time
        </p>
      ) : null}
      {isPopperOpen && (
        <FocusTrap
          active
          focusTrapOptions={{
            initialFocus: false,
            allowOutsideClick: true,
            clickOutsideDeactivates: true,
            onDeactivate: closePopper,
            fallbackFocus: popperRef.current,
          }}
        >
          <div
            tabIndex={-1}
            className="dialog-sheet timePicker dateTimeInputDialog"
            {...popper.attributes.popper}
            ref={setPopperElement}
            role="dialog"
          >
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <TimePicker
                autoOk
                variant="static"
                openTo="hours"
                value={timeValue}
                onChange={handleTimeChange}
              />
            </MuiPickersUtilsProvider>
          </div>
        </FocusTrap>
      )}
    </div>
  );
};

TimePickInput.propTypes = {
  timeValue: instanceOf(Date),
  handleTimeChange: func,
  showEventExpirationTimeError: bool,
  fromExtendEventExpiration: bool,
};

export default TimePickInput;
